<h1>My Listings</h1>
<h3>Items For Sale</h3>
<div *ngFor="let doc of myArray">
    <div *ngIf="doc.itemStatus == 'For Sale'">
        <div class="listing media" id = "listing-preview">
            <div class="photo">
                <img id="images" src={{doc.imageURL}} alt="listing image"/> 
            </div>
            
            <!--Display Books-->
            <div *ngIf="doc.category === 'books'" class="content media-body">
                <!-- Book Elements in Preview-->
                <h2><strong>{{doc.listingTitle}}</strong></h2> 
                <h4><strong>Price:</strong> ${{doc.price}}</h4>
                <br>
                <p><strong>Book Title: </strong>{{doc.bookTitle}}</p> 
                <br>
                <p><strong>Edition: </strong>{{doc.edition}}<strong> Course Number: </strong>{{doc.courseNum}}</p> 
                <br>
                <p><strong>Description: </strong>{{doc.description}}</p> 
                <br>
                <p><strong>Item Status: </strong>{{doc.itemStatus}}</p>
                <br>
                <p><strong>Exchange Location: </strong>{{doc.exchangeLoc}}<strong> Payment Option:</strong> {{doc.paymentOpt}}</p>
                <br>
                <p><strong>Seller: </strong>{{doc.email}}</p>
                
                <button class="button" mdbBtn type="button" mdbWavesEffect (click)="deleteListing(doc)">Delete</button>
                
                <button *ngIf="doc.itemStatus == 'For Sale'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsSold(doc)">Mark as sold</button>
                <button *ngIf="doc.itemStatus == 'Sold'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsForSale(doc)">Mark as for sale</button>
            </div>
            
            <!--Display Clothing-->
            <div *ngIf="doc.category === 'clothing'" class="content media-body">
                <!-- Book Elements in Preview-->
                <h2><strong>{{doc.listingTitle}}</strong></h2> 
                <h4><strong>Price:</strong> ${{doc.price}}</h4>
                <br>
                <p><strong>Type: </strong>{{doc.type}} <strong>Color: </strong>{{doc.color}}</p>
                <br> 
                <p><strong>Size: </strong>{{doc.size}}</p> 
                <br>
                <p><strong>Description: </strong>{{doc.description}}</p>
                <br>
                <p><strong>Item Status: </strong>{{doc.itemStatus}}</p>
                <br>
                <p><strong>Exchange Location: </strong>{{doc.exchangeLoc}} <strong>Payment Option:</strong> {{doc.paymentOpt}}</p>
                <br>
                <p><strong>Seller: </strong>{{doc.email}}</p>

                <button class="button" mdbBtn type="button" mdbWavesEffect (click)="deleteListing(doc)">Delete</button>

                <button *ngIf="doc.itemStatus == 'For Sale'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsSold(doc)">Mark as sold</button>
                <button *ngIf="doc.itemStatus == 'Sold'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsForSale(doc)">Mark as for sale</button>
            </div>

            <!--Display Furniture-->
            <div *ngIf="doc.category === 'furniture'" class="content media-body">
                <h2><strong>{{doc.listingTitle}}</strong></h2> 
                <h4><strong>Price:</strong> ${{doc.price}}</h4>
                <br>
                <p><strong>Type: </strong>{{doc.type}}</p> 
                <br>
                <p><strong>Color: </strong>{{doc.color}}</p> 
                <br>
                <p><strong>Length: </strong>{{doc.length}} in. <strong>Width: </strong>{{doc.width}} in. <strong> Height: </strong>{{doc.height}} in. </p> 
                <br>
                <p><strong>Weight: </strong>{{doc.weight}} lb.</p>   
                <br>
                <p><strong>Description: </strong>{{doc.description}}</p> 
                <br>
                <p><strong>Item Status: </strong>{{doc.itemStatus}}</p>
                <br>
                <p><strong>Exchange Location: </strong>{{doc.exchangeLoc}}
                <strong>Payment Option:</strong> {{doc.paymentOpt}}</p>
                <br>
                <p><strong>Seller: </strong>{{doc.email}}</p>
                    
                <button class="button" mdbBtn type="button" mdbWavesEffect (click)="deleteListing(doc)">Delete</button>

                <button *ngIf="doc.itemStatus == 'For Sale'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsSold(doc)">Mark as sold</button>
                <button *ngIf="doc.itemStatus == 'Sold'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsForSale(doc)">Mark as for sale</button>
            </div>

            <!--Display Electronics-->
            <div *ngIf="doc.category === 'electronics'" class="content media-body">
                <h2><strong>{{doc.listingTitle}}</strong></h2> 
                <h4><strong>Price:</strong> ${{doc.price}}</h4>
                <br>
                <p><strong>Type: </strong>{{doc.type}}</p> 
                <br>
                <p><strong>Model: </strong>{{doc.model}}</p> 
                <br>
                <p><strong>Length: </strong>{{doc.length}} in. <strong>Width: </strong>{{doc.width}} in. <strong> Height: </strong>{{doc.height}} in. </p> 
                <br>
                <p><strong>Weight: </strong>{{doc.weight}} lb.</p>   
                <br>
                <p><strong>Description: </strong>{{doc.description}}</p> 
                <br>
                <p><strong>Item Status: </strong>{{doc.itemStatus}}</p>
                <br>
                <p><strong>Exchange Location: </strong>{{doc.exchangeLoc}}
                <strong>Payment Option:</strong> {{doc.paymentOpt}}</p>
                <br>
                <p><strong>Seller: </strong>{{doc.email}}</p>

                <button class="button" mdbBtn type="button" mdbWavesEffect (click)="deleteListing(doc)">Delete</button>

                <button *ngIf="doc.itemStatus == 'For Sale'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsSold(doc)">Mark as sold</button>
                <button *ngIf="doc.itemStatus == 'Sold'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsForSale(doc)">Mark as for sale</button>
            </div>

            <!--Display Sports Gear-->
            <div *ngIf="doc.category === 'sportsgear'" class="content media-body">
                <h2><strong>{{doc.listingTitle}}</strong></h2> 
                <h4><strong>Price:</strong> ${{doc.price}}</h4>
                <br>
                <p><strong>Type: </strong>{{doc.type}}</p> 
                <br>
                <p><strong>Weight: </strong>{{doc.weight}} lb.</p>   
                <br>
                <p><strong>Description: </strong>{{doc.description}}</p> 
                <br>
                <p><strong>Item Status: </strong>{{doc.itemStatus}}</p>
                <br>
                <p><strong>Exchange Location: </strong>{{doc.exchangeLoc}}
                <strong>Payment Option:</strong> {{doc.paymentOpt}}</p>
                <br>
                <p><strong>Seller: </strong>{{doc.email}}</p>

                <button class="button" mdbBtn type="button" mdbWavesEffect (click)="deleteListing(doc)">Delete</button>

                <button *ngIf="doc.itemStatus == 'For Sale'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsSold(doc)">Mark as sold</button>
                <button *ngIf="doc.itemStatus == 'Sold'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsForSale(doc)">Mark as for sale</button>
            </div>
        </div>
    </div>
</div>

<h3>Sold Items</h3>
<div *ngFor="let doc of myArray">
    <div *ngIf="doc.itemStatus == 'Sold'">
        
        <div class="listing media" id = "listing-preview">

            <div class="photo">
                <img id="images" src={{doc.imageURL}} alt="listing image"/> 
            </div>
            
            <!--Display Books-->
            <div *ngIf="doc.category === 'books'" class="content media-body">
                <!-- Book Elements in Preview-->
                <h2><strong>{{doc.listingTitle}}</strong></h2> 
                <h4><strong>Price:</strong> ${{doc.price}}</h4>
                <br>
                <p><strong>Book Title: </strong>{{doc.bookTitle}}</p> 
                <br>
                <p><strong>Edition: </strong>{{doc.edition}}<strong> Course Number: </strong>{{doc.courseNum}}</p> 
                <br>
                <p><strong>Description: </strong>{{doc.description}}</p> 
                <br>
                <p><strong>Item Status: </strong>{{doc.itemStatus}}</p>
                <br>
                <p><strong>Exchange Location: </strong>{{doc.exchangeLoc}}<strong> Payment Option:</strong> {{doc.paymentOpt}}</p>
                <br>
                <p><strong>Seller: </strong>{{doc.email}}</p>
                
                <button class="button" mdbBtn type="button" mdbWavesEffect (click)="deleteListing(doc)">Delete</button>
                
                <button *ngIf="doc.itemStatus == 'For Sale'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsSold(doc)">Mark as sold</button>
                <button *ngIf="doc.itemStatus == 'Sold'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsForSale(doc)">Mark as for sale</button>
            </div>
            
            <!--Display Clothing-->
            <div *ngIf="doc.category === 'clothing'" class="content media-body">
                <!-- Book Elements in Preview-->
                <h2><strong>{{doc.listingTitle}}</strong></h2> 
                <h4><strong>Price:</strong> ${{doc.price}}</h4>
                <br>
                <p><strong>Type: </strong>{{doc.type}} <strong>Color: </strong>{{doc.color}}</p>
                <br> 
                <p><strong>Size: </strong>{{doc.size}}</p> 
                <br>
                <p><strong>Description: </strong>{{doc.description}}</p>
                <br>
                <p><strong>Item Status: </strong>{{doc.itemStatus}}</p>
                <br>
                <p><strong>Exchange Location: </strong>{{doc.exchangeLoc}} <strong>Payment Option:</strong> {{doc.paymentOpt}}</p>
                <br>
                <p><strong>Seller: </strong>{{doc.email}}</p>

                <button class="button" mdbBtn type="button" mdbWavesEffect (click)="deleteListing(doc)">Delete</button>

                <button *ngIf="doc.itemStatus == 'For Sale'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsSold(doc)">Mark as sold</button>
                <button *ngIf="doc.itemStatus == 'Sold'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsForSale(doc)">Mark as for sale</button>
            </div>

            <!--Display Furniture-->
            <div *ngIf="doc.category === 'furniture'" class="content media-body">
                <h2><strong>{{doc.listingTitle}}</strong></h2> 
                <h4><strong>Price:</strong> ${{doc.price}}</h4>
                <br>
                <p><strong>Type: </strong>{{doc.type}}</p> 
                <br>
                <p><strong>Color: </strong>{{doc.color}}</p> 
                <br>
                <p><strong>Length: </strong>{{doc.length}} in. <strong>Width: </strong>{{doc.width}} in. <strong> Height: </strong>{{doc.height}} in. </p> 
                <br>
                <p><strong>Weight: </strong>{{doc.weight}} lb.</p>   
                <br>
                <p><strong>Description: </strong>{{doc.description}}</p> 
                <br>
                <p><strong>Item Status: </strong>{{doc.itemStatus}}</p>
                <br>
                <p><strong>Exchange Location: </strong>{{doc.exchangeLoc}}
                <strong>Payment Option:</strong> {{doc.paymentOpt}}</p>
                <br>
                <p><strong>Seller: </strong>{{doc.email}}</p>
                    
                <button class="button" mdbBtn type="button" mdbWavesEffect (click)="deleteListing(doc)">Delete</button>

                <button *ngIf="doc.itemStatus == 'For Sale'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsSold(doc)">Mark as sold</button>
                <button *ngIf="doc.itemStatus == 'Sold'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsForSale(doc)">Mark as for sale</button>
            </div>

            <!--Display Electronics-->
            <div *ngIf="doc.category === 'electronics'" class="content media-body">
                <h2><strong>{{doc.listingTitle}}</strong></h2> 
                <h4><strong>Price:</strong> ${{doc.price}}</h4>
                <br>
                <p><strong>Type: </strong>{{doc.type}}</p> 
                <br>
                <p><strong>Model: </strong>{{doc.model}}</p> 
                <br>
                <p><strong>Length: </strong>{{doc.length}} in. <strong>Width: </strong>{{doc.width}} in. <strong> Height: </strong>{{doc.height}} in. </p> 
                <br>
                <p><strong>Weight: </strong>{{doc.weight}} lb.</p>   
                <br>
                <p><strong>Description: </strong>{{doc.description}}</p> 
                <br>
                <p><strong>Item Status: </strong>{{doc.itemStatus}}</p>
                <br>
                <p><strong>Exchange Location: </strong>{{doc.exchangeLoc}}
                <strong>Payment Option:</strong> {{doc.paymentOpt}}</p>
                <br>
                <p><strong>Seller: </strong>{{doc.email}}</p>

                <button class="button" mdbBtn type="button" mdbWavesEffect (click)="deleteListing(doc)">Delete</button>

                <button *ngIf="doc.itemStatus == 'For Sale'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsSold(doc)">Mark as sold</button>
                <button *ngIf="doc.itemStatus == 'Sold'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsForSale(doc)">Mark as for sale</button>
            </div>

            <!--Display Sports Gear-->
            <div *ngIf="doc.category === 'sportsgear'" class="content media-body">
                <h2><strong>{{doc.listingTitle}}</strong></h2> 
                <h4><strong>Price:</strong> ${{doc.price}}</h4>
                <br>
                <p><strong>Type: </strong>{{doc.type}}</p> 
                <br>
                <p><strong>Weight: </strong>{{doc.weight}} lb.</p>   
                <br>
                <p><strong>Description: </strong>{{doc.description}}</p> 
                <br>
                <p><strong>Item Status: </strong>{{doc.itemStatus}}</p>
                <br>
                <p><strong>Exchange Location: </strong>{{doc.exchangeLoc}}
                <strong>Payment Option:</strong> {{doc.paymentOpt}}</p>
                <br>
                <p><strong>Seller: </strong>{{doc.email}}</p>

                <button class="button" mdbBtn type="button" mdbWavesEffect (click)="deleteListing(doc)">Delete</button>

                <button *ngIf="doc.itemStatus == 'For Sale'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsSold(doc)">Mark as sold</button>
                <button *ngIf="doc.itemStatus == 'Sold'" class="button" mdbBtn type="button" mdbWavesEffect (click)="markAsForSale(doc)">Mark as for sale</button>
            </div>
        </div>
    </div>
</div>
